// Constants
const panelDisplay = document.querySelector('.location-list-map__panels');
const bp = 900;

// Utility function to set heights based on conditions
function setElementHeight(element, totalHeight, subtractHeight) {
  if (window.innerWidth >= bp) {
    element.style.height = `calc(${totalHeight}px - ${subtractHeight}px)`;
  } else {
    element.style.height = 'auto';
  }
}

// Adjusts the height of list display panels
function adjustListDisplayHeight() {
  const panelTop = document.querySelector('.location-list-map__left-panel-top');
  const listDisplay = document.querySelector('.location-list-map__filter-lists');

  if (panelDisplay && panelTop && listDisplay) {
    const panelHeight = panelDisplay.offsetHeight;
    const listHeight = panelTop.offsetHeight;
    setElementHeight(listDisplay, panelHeight, listHeight);
  }
}

// Adjusts the height of filter dropdowns
function adjustFilterDisplayHeight() {
  const closeFilters = document.querySelector('.rail-filter__location-filter-button');
  const filterDisplay = document.querySelector('.rail-filters__location-result-dropdown');

  if (panelDisplay && closeFilters && filterDisplay) {
    const panelHeight = panelDisplay.offsetHeight;
    const filterHeight = closeFilters.offsetHeight;
    setElementHeight(filterDisplay, panelHeight, filterHeight);
  }
}

// Toggle visibility of filter dropdown
function toggleFilterDropdown() {
  const filterButton = document.querySelector('.location-list-map__filter-results');
  const filterDropdown = document.querySelector('.rail-filter__location-filter');
  const closeButton = document.querySelector('.rail-filter__location-filter-button');
  const locationFound = document.querySelector('.location-list-map__content');
  const filterLists = document.querySelector('.location-list-map__filter-lists');
  const mapPanel = document.querySelector('.location-list-map__map-panel');
  const toggleButtonLeft = document.querySelector('.toggle-button__filter-result .toggle-button-list__left');
  const toggleButtonRight = document.querySelector('.toggle-button__filter-result .toggle-button-list__right');

  let currentView = 'list';

  if (filterButton && filterDropdown) {
    filterButton.addEventListener('click', () => {
      filterDropdown.classList.toggle('open');
      filterButton.style.display = filterDropdown.classList.contains('open') ? 'none' : 'inline-block';
      locationFound.classList.add('hidden');
      filterLists.classList.toggle('hidden');
      adjustFilterDisplayHeight();

      if (window.innerWidth < bp) {
        filterLists.style.display = 'block';
        mapPanel.style.display = 'none';
        toggleButtonLeft.setAttribute('aria-selected', 'true');
        toggleButtonRight.setAttribute('aria-selected', 'false');
        currentView = 'list';
      }
    });

    closeButton.addEventListener('click', () => {
      filterDropdown.classList.remove('open');
      filterButton.style.display = 'flex';
      locationFound.classList.remove('hidden');
      filterLists.classList.remove('hidden');
    });
  }

  // Toggle between List and Map view on smaller screens
  function setupToggleButtons() {
    function toggleView() {
      if (window.innerWidth >= bp) {
        filterLists.style.display = '';
        mapPanel.style.display = '';
      } else if (currentView === 'list') {
        filterLists.style.display = 'block';
        mapPanel.style.display = 'none';
      } else {
        filterLists.style.display = 'none';
        mapPanel.style.display = 'flex';
      }
    }

    toggleButtonLeft.addEventListener('click', () => {
      filterLists.style.display = 'block';
      mapPanel.style.display = 'none';
      toggleButtonLeft.setAttribute('aria-selected', 'true');
      toggleButtonRight.setAttribute('aria-selected', 'false');
      currentView = 'list';
    });

    toggleButtonRight.addEventListener('click', () => {
      filterLists.style.display = 'none';
      mapPanel.style.display = 'flex';
      toggleButtonRight.setAttribute('aria-selected', 'true');
      toggleButtonLeft.setAttribute('aria-selected', 'false');
      currentView = 'map';
    });

    toggleView();
    window.addEventListener('resize', toggleView);
  }

  setupToggleButtons();
}

// Initialize if the component has loaded
if (panelDisplay) {
  adjustListDisplayHeight();
  window.addEventListener('resize', adjustListDisplayHeight);

  document.addEventListener('DOMContentLoaded', () => {
    toggleFilterDropdown();
  });
}
